import { Injectable } from '@angular/core';
import { UserStateDataEntryValueExcludingUserFirstLogin } from '@osos/shared/api';
import { UserStateExcludingUserFirstLoginPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases';
@Injectable({
  providedIn: 'root',
})
export class UserStateExcludingParserV1Service extends ParserBase<
  UserStateDataEntryValueExcludingUserFirstLogin,
  UserStateExcludingUserFirstLoginPresenterModel
> {
  override getPresenterModel(
    model: Partial<UserStateDataEntryValueExcludingUserFirstLogin>,
  ): UserStateExcludingUserFirstLoginPresenterModel {
    return {
      dateFormat: model.dateFormat,
      dateTimeFormat: model.dateTimeFormat,
      fontSize: model.fontSize,
      language: model.language,
      layoutMode: model.layoutMode,
      menuMode: model.menuMode,
      theme: model.theme,
      timeFormat: model.timeFormat,
      timeZone: model.timeZone,
    } as UserStateExcludingUserFirstLoginPresenterModel;
  }
  override getDataModel(
    presenter: UserStateExcludingUserFirstLoginPresenterModel,
  ): UserStateDataEntryValueExcludingUserFirstLogin {
    return {
      dateFormat: presenter.dateFormat,
      dateTimeFormat: presenter.dateTimeFormat,
      fontSize: presenter.fontSize,
      language: presenter.language,
      layoutMode: presenter.layoutMode,
      menuMode: presenter.menuMode,
      theme: presenter.theme,
      timeFormat: presenter.timeFormat,
      timeZone: presenter.timeZone,
    } as UserStateDataEntryValueExcludingUserFirstLogin;
  }
  constructor() {
    super(
      UserStateDataEntryValueExcludingUserFirstLogin,
      UserStateExcludingUserFirstLoginPresenterModel,
      1,
    );
  }
}
